export const PostPatient = async (resource,data) => {
    let result
    await resource
        .post(`api/${localStorage.getItem('perfil')}/patient`,data)
        .then(
            (response) => {
                result = response.body.patient
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}
export const PatientFindByRut = async (resource,rut) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/patient/find_by_document/${rut}`)
        .then(
            (response) => {
                result = response.body.patient
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}